export default "/institutions/ticket.svg";